export default __webpack_public_path__ + "footer.d04694d.png";